<template>
  <div class="mobile-container images-pagination__root">
    <template v-if="title">
      <div class="pagination-title">{{ title }}</div>
    </template>
    <div
      class="images-pagination"
      :class="{'--open': isOpen}"
    >
      <div
        v-for="(item) in itemsFormat"
        :key="`image-pagination-${item.index}`"
        class="images-pagination__item"
        :class="{ '--active': item.index === active}"
        @click="() => onChangeActive(item.index)"
      >
        <nuxt-img
          :src="String(item.imageId)"
          :width="180"
          :height="120"
          class=""
          :class="{'object-cover': isCrop}"
          loading="lazy"
        />
      </div>

      <template v-if="isShowButtonMore">
        <div
          class="images-pagination__item button-more"
          @click="openMore"
        >
          {{ labelButtonMore }}
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">

interface IImages {
  imageId: number;
  index: number;
}

const props = withDefaults(defineProps<{
  images: IImages[];
  title?: string;
  active: number;
  total: number;
  isCrop?: boolean;
  limitItems?: number;
}>(), {
  title: '',
  active: 1,
  total: 0,
  isCrop: false,
  limitItems: 6
});

const emit = defineEmits<{(e: 'onChangeActive', index: number): void
}>();

const isOpen = ref(false);

const itemsFormat = computed(() => {
  if (!isOpen.value && props.images.length > 7) {
    return [...props.images].splice(0, props.limitItems);
  }

  return props.images;
});

const labelButtonMore = computed(() => `+ ${[...props.images].length - props.limitItems} фото`);

const isShowButtonMore = computed(() => Boolean(!isOpen.value && props.images.length > props.limitItems));

const openMore = () => {
  isOpen.value = true;
};

const onChangeActive = (index: number) => {
  emit('onChangeActive', index);
};

</script>

<style lang="scss">
.images-pagination__root {
  overflow: hidden;
}
.pagination-title {
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: #000;
  margin-bottom: 6px;
}

.images-pagination {
  display: flex;
  flex-wrap: nowrap;
  margin-top: -2px;
  margin-left: -2px;

  &.--open {
    flex-wrap: wrap;
  }
}

.images-pagination__item {
  position: relative;
  overflow: hidden;
  min-width: calc(100% / 7 - 2px);
  max-width: calc(100% / 7 - 2px);
  height: 60px;
  margin-top: 2px;
  margin-left: 2px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & > img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: linear-gradient(0deg, rgb(255 255 255 / 60%), rgb(255 255 255 / 60%));
  }

  &:hover {
    &::after {
      opacity: 0.6;
    }
  }

  &.--active {
    &::after {
      content: none;
    }
  }
}

.button-more {
  background: #FFF;
  border: 1px solid red;
  box-sizing: border-box;
  border-radius: 5px;
  transition: all 0.2s;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.02em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #000;

  &::after {
    content: none;
  }

  &:hover {
    box-shadow: 0 0 3px 0 red;
  }
}
</style>
